import { field } from "@mc/mc-legacy";
import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import { columnPropType, rowPropType } from "./propTypes";
import { getCellClassName } from "./utils";
const { Checkbox } = field;
export default class DataTableSelectionCell extends PureComponent {
  static propTypes = {
    column: columnPropType.isRequired,
    row: rowPropType,
    value: PropTypes.bool,
    onChange: PropTypes.func,
  };
  static defaultProps = {
    value: false,
  };
  handleChange = () => {
    const { column, row, value, onChange } = this.props;

    if (onChange) {
      if (row) {
        onChange(row, !value, column);
      } else {
        onChange(!value, column);
      }
    }
  };

  render() {
    const { className, column, row, value, onChange, ...otherProps } = this.props;
    const compositeClassName = getCellClassName(column, className);
    const Tag = row ? "td" : "th";
    return (
      <Tag className={compositeClassName} {...otherProps}>
        <Checkbox value={value} onChange={this.handleChange} />
      </Tag>
    );
  }
}
